import { Link } from "react-router-dom";

const LINKS = [
  { to: "/terms", label: "Terms of Service" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/service-agreement", label: "Service Agreement" },
  { to: "/refund-policy", label: "Refund Policy" },
];

export const LegalFooter = ({ className = "" }) => (
  <div
    className={`mt-10 pt-6 border-t border-zinc-200 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-zinc-400 ${className}`}
    data-testid="legal-footer"
  >
    {LINKS.map((l) => (
      <Link key={l.to} to={l.to} className="hover:text-zinc-700 transition" data-testid={`legal-footer-${l.to.slice(1)}`}>
        {l.label}
      </Link>
    ))}
  </div>
);
